export const CUSTOMER_TOKEN_KEY = "customer_token";

export const getCustomerToken = () => localStorage.getItem(CUSTOMER_TOKEN_KEY);

export const setCustomerToken = (token) => {
  localStorage.setItem(CUSTOMER_TOKEN_KEY, token);
  window.dispatchEvent(new Event("customer_auth_changed"));
};

export const clearCustomerToken = () => {
  localStorage.removeItem(CUSTOMER_TOKEN_KEY);
  window.dispatchEvent(new Event("customer_auth_changed"));
};

export const isCustomerLoggedIn = () => !!getCustomerToken();